import { render, staticRenderFns } from "./IconContact.vue?vue&type=template&id=e88f0f46&"
import script from "./IconContact.vue?vue&type=script&lang=js&"
export * from "./IconContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports